import { getFindPersonJobsListQueryKey, useConfirmPersonJobs } from '@api';
import { useNotification } from '@common';
import { useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type UseConfirmJobsReturnType = {
  confirmJobs: (jobIds: string[]) => void;
};

export const useConfirmJobs = (personId: string): UseConfirmJobsReturnType => {
  const queryClient = useQueryClient();
  const { mutate: confirmJobsMutation } = useConfirmPersonJobs();
  const { showError, showSuccess } = useNotification();

  const onSuccess = (): void => {
    queryClient.invalidateQueries({
      queryKey: getFindPersonJobsListQueryKey(personId, {
        type: 'UNCONFIRMED',
      }),
    });
    queryClient.invalidateQueries({
      queryKey: getFindPersonJobsListQueryKey(personId, { type: 'UPCOMING' }),
    });
    queryClient.invalidateQueries({
      queryKey: getFindPersonJobsListQueryKey(personId, { type: 'PREVIOUS' }),
    });
    showSuccess({
      title: 'NOTIFICATIONS.CONFIRM_JOBS.SUCCESS.TITLE',
      message: 'NOTIFICATIONS.CONFIRM_JOBS.SUCCESS.MESSAGE',
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: 'NOTIFICATIONS.CONFIRM_JOBS.ERROR.TITLE',
      message: 'NOTIFICATIONS.CONFIRM_JOBS.ERROR.MESSAGE',
      error,
    });
  };

  const confirmJobs = (jobIds: string[]): void => {
    confirmJobsMutation(
      {
        data: { data: { jobIds } },
        id: personId,
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { confirmJobs };
};
